const MAX_HISTORY_SIZE = 10

export function useHistory() {
  const historyStack = []
  const futureStack = []
  let isUndoRedoAction = false

  function getCanUndo() {
    return historyStack.length > 0
  }

  function getCanRedo() {
    return futureStack.length > 0
  }

  function getHistoryLength() {
    return historyStack.length
  }

  function getFutureLength() {
    return futureStack.length
  }

  function saveState(state, actionName = '') {
    if (isUndoRedoAction) {
      return
    }
    
    const snapshot = {
      timestamp: Date.now(),
      actionName,
      data: JSON.parse(JSON.stringify(state))
    }
    
    historyStack.push(snapshot)
    
    if (historyStack.length > MAX_HISTORY_SIZE) {
      historyStack.shift()
    }
    
    futureStack.length = 0
    console.log('📜 useHistory.saveState - historyLength:', historyStack.length)
  }

  function undo(currentState) {
    if (!getCanUndo()) {
      return null
    }
    
    isUndoRedoAction = true
    
    const currentSnapshot = {
      timestamp: Date.now(),
      actionName: 'current',
      data: JSON.parse(JSON.stringify(currentState))
    }
    futureStack.push(currentSnapshot)
    
    if (futureStack.length > MAX_HISTORY_SIZE) {
      futureStack.shift()
    }
    
    const previousState = historyStack.pop()
    
    isUndoRedoAction = false
    
    return previousState?.data || null
  }

  function redo(currentState) {
    if (!getCanRedo()) {
      return null
    }
    
    isUndoRedoAction = true
    
    const currentSnapshot = {
      timestamp: Date.now(),
      actionName: 'current',
      data: JSON.parse(JSON.stringify(currentState))
    }
    historyStack.push(currentSnapshot)
    
    if (historyStack.length > MAX_HISTORY_SIZE) {
      historyStack.shift()
    }
    
    const nextState = futureStack.pop()
    
    isUndoRedoAction = false
    
    return nextState?.data || null
  }

  function clearHistory() {
    historyStack.length = 0
    futureStack.length = 0
  }

  function clearForZone() {
    historyStack.length = 0
    futureStack.length = 0
  }

  return {
    getCanUndo,
    getCanRedo,
    getHistoryLength,
    getFutureLength,
    saveState,
    undo,
    redo,
    clearHistory,
    clearForZone
  }
}
